import http from '../../utils/http';

export default {
    /**
     * 获取当前加盟商的省份列表
     *
     * @returns
     */
    getCurrentShopProvince() {
        return http({
            url: 'common/GetCurrentShopProvince',
            method: 'GET',
            headers: {
                showLoading: false
            }
        });
    },
    /**
     * 根据区县获取学校列表
     *
     * @param {*} data
     * @returns
     */
    getSchoolByArea(data) {
        return http({
            url: 'common/GetSchoolByArea',
            method: 'GET',
            params: data,
            headers: {
                showLoading: false
            }
        });
    },
    // 跳转外部链接
    getOutUrl() {
        return http({
            url: 'Common/GetEegulationsUrl',
            method: 'GET'
        });
    },
    // 获取注册页面提示内容
    getRegisterNotice() {
        return http({
            url: 'WebsiteSet/GetRegisterPageNotice',
            method: 'GET'
        });
    }
};
